module.exports = __webpack_public_path__ + "static/self-image-f2ef8da4c65c2df64de82c48623538c9.jpg";